import { render, staticRenderFns } from "./PublicArticlesPage.vue?vue&type=template&id=80658a3a&scoped=true&"
import script from "./PublicArticlesPage.vue?vue&type=script&lang=js&"
export * from "./PublicArticlesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80658a3a",
  null
  
)

export default component.exports